module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"typekit":{"id":"suh6sqd"},"google":{"families":["Roboto Mono"]}},
    }]
